import moment from 'moment'

import { IBlock } from '../../types'
import { IAPIBlock } from '../../types/api'

export const apiBlocksTransformer = (data: IAPIBlock[]): IBlock[] =>
  data.map(apiBlock => ({
    uuid: apiBlock.uuid,
    id: apiBlock.id,
    name: apiBlock.name,
    blockedCategoryUuid: apiBlock.blocked_category_uuid,
    color: apiBlock.color,
    altColor: apiBlock.alt_color,
    startsAt: moment(apiBlock.starts_at),
    endsAt: moment(apiBlock.ends_at),
    notes: apiBlock.notes,
    personId: apiBlock.person_id,
    personUuid: apiBlock.person_uuid,
    isRepeat: apiBlock.is_repeat,
  }))
